export default __webpack_public_path__ + "static/media/family.0748a8ac.png";